package com.nonopn.skywatcher.maps

data class Circle(
    val position: LatLng,
    val radiusKm: Int
) {
    fun distanceTo(circle: Circle) = distanceTo(circle.position)

    fun distanceTo(latLng: LatLng) = MapUtils.distance(position, latLng)
}
